export default {
  agency_key: '',
  mode: '',
  chat_url: 'https://chat.ruan.net',
  beian: '',
  beian_gn: '',

  address: '云南省大理市下关建设西路云路中心首座702室',
  uc_host: 'http://i.media.lrswl.com',
  site_host: 'http://media.lrswl.com',
  special_url: '/',
  site_title: '老榕树媒盟-软文精准营销平台',
  welcome_title: '老榕树媒盟 — 软文精准营销平台！',
  site_short_title: '老榕树媒盟',
  site_subtitle: '软文精准营销平台',
  company_name: '大理老榕树网络科技有限责任公司',
  copyright: '© 2019 大理老榕树网络科技有限责任公司',
  logo: 'http://media.lrswl.com/img/logo.png',
  favicon: 'http://media.lrswl.com/favicon.ico',
  payment: '',
  qq: '4000929998',
  tel: '400-092-9998',
  company_account_id: '2515101309024503685',
  company_bank: '中国工商银行股份有限公司大理苍山西路支行',
  company_bank_name: '大理老榕树网络科技有限责任公司',
  alipay_account_id: '303979928@qq.com',
  alipay_name: '大理老榕树网络科技有限责任公司',
  alipay_pic: '',
  section_id: 89034,
  belonger_id: 89034,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 